import React from "react";
import { styled } from "@mui/material";

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  fontSize: "10px",
  width: "60px",
  gap: "4px",
  textAlign: "center",
});

export const MobileIconWithTitle = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};
